/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateOperatorDetails } from '../model/createOperatorDetails';
import { JsonResult } from '../model/jsonResult';
import { OperatorDetailsDto } from '../model/operatorDetailsDto';
import { ProblemDetails } from '../model/problemDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class OperatorDetailsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOperatorDetailsCreatePost(body?: CreateOperatorDetails, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiOperatorDetailsCreatePost(body?: CreateOperatorDetails, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiOperatorDetailsCreatePost(body?: CreateOperatorDetails, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiOperatorDetailsCreatePost(body?: CreateOperatorDetails, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/OperatorDetails/Create`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param Id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOperatorDetailsDeleteDelete(Id?: string, observe?: 'body', reportProgress?: boolean): Observable<JsonResult>;
    public apiOperatorDetailsDeleteDelete(Id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonResult>>;
    public apiOperatorDetailsDeleteDelete(Id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonResult>>;
    public apiOperatorDetailsDeleteDelete(Id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Id !== undefined && Id !== null) {
            queryParameters = queryParameters.set('Id', <any>Id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<JsonResult>('delete',`${this.basePath}/api/OperatorDetails/Delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOperatorDetailsGetAllOperatorsGet(skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<OperatorDetailsDto>>;
    public apiOperatorDetailsGetAllOperatorsGet(skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OperatorDetailsDto>>>;
    public apiOperatorDetailsGetAllOperatorsGet(skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OperatorDetailsDto>>>;
    public apiOperatorDetailsGetAllOperatorsGet(skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OperatorDetailsDto>>('get',`${this.basePath}/api/OperatorDetails/GetAllOperators`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param areaId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOperatorDetailsGetOperatorDetailsByAreaIdGet(areaId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<OperatorDetailsDto>>;
    public apiOperatorDetailsGetOperatorDetailsByAreaIdGet(areaId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OperatorDetailsDto>>>;
    public apiOperatorDetailsGetOperatorDetailsByAreaIdGet(areaId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OperatorDetailsDto>>>;
    public apiOperatorDetailsGetOperatorDetailsByAreaIdGet(areaId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (areaId !== undefined && areaId !== null) {
            queryParameters = queryParameters.set('areaId', <any>areaId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OperatorDetailsDto>>('get',`${this.basePath}/api/OperatorDetails/GetOperatorDetailsByAreaId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param _id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOperatorDetailsGetOperatorDetailsByIdGet(_id?: string, observe?: 'body', reportProgress?: boolean): Observable<OperatorDetailsDto>;
    public apiOperatorDetailsGetOperatorDetailsByIdGet(_id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OperatorDetailsDto>>;
    public apiOperatorDetailsGetOperatorDetailsByIdGet(_id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OperatorDetailsDto>>;
    public apiOperatorDetailsGetOperatorDetailsByIdGet(_id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (_id !== undefined && _id !== null) {
            queryParameters = queryParameters.set('_id', <any>_id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<OperatorDetailsDto>('get',`${this.basePath}/api/OperatorDetails/GetOperatorDetailsById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param operatorId 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOperatorDetailsGetOperatorDetailsByOperatorIdGet(operatorId?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<OperatorDetailsDto>>;
    public apiOperatorDetailsGetOperatorDetailsByOperatorIdGet(operatorId?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OperatorDetailsDto>>>;
    public apiOperatorDetailsGetOperatorDetailsByOperatorIdGet(operatorId?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OperatorDetailsDto>>>;
    public apiOperatorDetailsGetOperatorDetailsByOperatorIdGet(operatorId?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (operatorId !== undefined && operatorId !== null) {
            queryParameters = queryParameters.set('operatorId', <any>operatorId);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OperatorDetailsDto>>('get',`${this.basePath}/api/OperatorDetails/GetOperatorDetailsByOperatorId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOperatorDetailsUpdatePut(body?: OperatorDetailsDto, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiOperatorDetailsUpdatePut(body?: OperatorDetailsDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiOperatorDetailsUpdatePut(body?: OperatorDetailsDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiOperatorDetailsUpdatePut(body?: OperatorDetailsDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/OperatorDetails/Update`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
